import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const IntegrationsHeader = ({ integration }) => {
  const intl = useIntl();

  return (
    <header className="page-header">
      <h3 className="page-title">
        {integration ? (
          <>
            <img
              src={integration.logo_url}
              alt={integration.name}
            />
            {integration.name}
          </>
        ) : (
          <>
            {intl.formatMessage({ defaultMessage: 'Integrations' })}
          </>
        )}
      </h3>
    </header>
  );
};

IntegrationsHeader.propTypes = {
  integration: PropTypes.object,
};

IntegrationsHeader.defaultProps = {
  integration: null,
};

export default IntegrationsHeader;
